import { useRouter } from "next/router";
import { useEffect } from "react";
import { saveUtmFromQuery } from "utils/utm-storage";

/**
 * Persists UTM params from the URL into sessionStorage on every route change so
 * attribution survives in-site navigation to pages with clean URLs. Renders
 * nothing.
 */
const UtmCapture = (): null => {
    const { query } = useRouter();

    useEffect(() => {
        saveUtmFromQuery(query);
    }, [query]);

    return null;
};

export default UtmCapture;
